import React from 'react';

import getClassNames from 'classnames';

import Element, { CommonProps } from '../../Element/Element';
import styles from '../Table.module.scss';
import { ArrayElementType } from '../../../types/utils/ArrayElementType';

const tableTypeOptions = ['default', 'checkbox'] as const;

export type tableTypeOption = ArrayElementType<typeof tableTypeOptions>;

type TableCellProps = {
  /**  Allows TableCells to adjust accordingly. */
  type?: tableTypeOption;
  /** If content doesn't fit to the cell, the word is cut and wrapped to the next row. This props adds word-break: break-all style to the cell */
  breakWord?: boolean;
  ref?: React.Ref<HTMLTableDataCellElement>;
} & Omit<CommonProps<'td'>, 'tagName' | 'ref'>;

const TableCell: React.FunctionComponent<TableCellProps> = React.forwardRef(
  function TableCell(
    { className, children, type, breakWord, ...props },
    ref: React.Ref<HTMLTableDataCellElement>
  ) {
    const classNames = getClassNames(
      styles.table_cell,
      { [styles.table_cell_checkbox]: type === 'checkbox' },
      { [styles.table_cell__breakWord]: breakWord },
      className
    );

    return (
      <Element tagName="td" ref={ref} className={classNames} {...props}>
        {children}
      </Element>
    );
  }
);

export default TableCell;
